<template>
  <div class="">
    <div
      class="grid gap-6"
      :class="{
        'grid-cols-1': !$attrs.grid,
        'grid-cols-2': !!$attrs.grid
      }"
    >
      <div
        v-for="service in sortedServices"
        class="bg-white p-4 rounded-4xl pb-0"
        :class="{
          'grayscale opacity-50 pointer-events-none':
            !isServiceAnyOptionAvailable(service)
        }"
        v-show="!$attrs.group || $attrs.group == service.group"
      >
        <div class="w-16 min-w-16 h-16 mb-2" v-if="!$attrs.iconOnOptions">
          <ImgComponent
            :src="service.logo"
            class="w-full h-full rounded-2xl"
            alt=""
          />
        </div>
        <component
          :is="option.url ? 'a' : 'div'"
          target="_blank"
          :href="option.url"
          v-for="option in $constants.SERVICES.SERVICES_OPTIONS[service.id] ||
          service.options"
          class="flex justify-left w-full ripple mb-4 items-center gap-4"
          :class="{ 'grayscale opacity-50 pointer-events-none': !isOptionAvailable(service.id, option.id) }"
          @click="
            !option.url &&
              $bus.emit($constants.EVENTS.SERVICES.OPTIONS.SELECTED, option)
          "
          v-show="!$attrs.option || $attrs.option == option.id"
        >
          <div class="w-16 min-w-16 h-16 mb-2" v-if="$attrs.iconOnOptions">
            <ImgComponent
              :src="service.logo"
              class="w-full h-full rounded-2xl"
              alt=""
            />
          </div>
          <div>
            <div class="text-xl title-color font-semibold">
              {{ option.title }}
            </div>
            <div class="description-color text-lg" v-if="!$attrs.hideDesc">
              {{ option.smallDescription }}
            </div>
          </div>
          <div class="h-full flex items-center ml-auto">
            <div
              class="w-10 min-w-10 mt-1 h-10 bg-[#EFEFFE] rounded-full p-3 flex items-center justify-center"
            >
              <ColorImg
                src="/images/icons/right-arrow.svg"
                class="w-full h-full bg-gray-400"
                alt=""
              />
            </div>
          </div>
        </component>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getStore } from '@core/store';
import { computed, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const userStore = getStore('user');
const userCountry = computed(() => userStore.state.current?.countryCode);

const sortedServices = computed(() => {
  return [...proxy.$constants.SERVICES.SERVICES_LIST];
});

const isOptionAvailable = (serviceId, operationId) => {
  const countryCode = userCountry.value;
  const appData = proxy.$stores.appData.state.data;
  
  const operationKeys = {
    'fund:1xbet': 'fund1xBet',
    'withdraw:1xbet': 'withdrawal1xBet',
    'fund:betwinner': 'fundBetWinner',
    'withdraw:betwinner': 'withdrawalBetWinner',
    'fund:1win': 'fund1Win',
    'withdraw:1win': 'withdrawal1Win',
    'fund:melbet': 'fundMelbet',
    'withdraw:melbet': 'withdrawalMelbet',
    'fund:eightStarz': 'fundEightStarz',
    'withdraw:eightStarz': 'withdrawalEightStarz',
    'buy:usdt': 'buyUsdt',
    'sell:usdt': 'sellUsdt'
  };
  
  const key = `${operationId}:${serviceId}`;
  const opKey = operationKeys[key];
  if (!opKey) return true;
  
  return appData?.serviceAvailability?.[countryCode]?.[opKey] ?? true;
};

const isServiceAnyOptionAvailable = (service) => {
  const countryCode = userCountry.value;
  const appData = proxy.$stores.appData.state.data;
  const availability = appData?.serviceAvailability?.[countryCode];
  if (!availability) return true;

  if (service.id === '1xbet') return availability.fund1xBet || availability.withdrawal1xBet;
  if (service.id === 'betwinner') return availability.fundBetWinner || availability.withdrawalBetWinner;
  if (service.id === '1win') return availability.fund1Win || availability.withdrawal1Win;
  if (service.id === 'melbet') return availability.fundMelbet || availability.withdrawalMelbet;
  if (service.id === 'eightStarz') return availability.fundEightStarz || availability.withdrawalEightStarz;
  if (service.id === 'usdt') return availability.buyUsdt || availability.sellUsdt;

  return true;
};
</script>
